import NullCheckUtil from './NullCheckUtil';

export const convertTimestampToFormatString = (timestamp) => {
    return new Intl.DateTimeFormat('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(timestamp);
};

export const convertTimestampToDate = (timestamp) => {
    return new Intl.DateTimeFormat('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(timestamp);
};

const paddingZero = (value) => {
    if (value < 10) {
        return '0' + value;
    } else {
        return '' + value;
    }
};

export const formatUiDttm = (millis) => {
    if (NullCheckUtil.isNotNull(millis) && millis != 0) {
        var date = new Date(millis);
        return (
            date.getFullYear() +
            '-' +
            paddingZero(date.getMonth() + 1) +
            '-' +
            paddingZero(date.getDate()) +
            ' ' +
            paddingZero(date.getHours()) +
            ':' +
            paddingZero(date.getMinutes())
        );
    } else {
        return ' ';
    }
};

export const formatDt = (millis) => {
    if (NullCheckUtil.isNotNull(millis) && millis != 0) {
        var date = new Date(millis);
        return ''.concat(date.getFullYear(), paddingZero(date.getMonth() + 1), paddingZero(date.getDate()));
    } else {
        return ' ';
    }
};

export const sessionValidTime = () => {
    var tDate = new Date();
    tDate.setMinutes(tDate.getMinutes() + 60);
    return tDate;
};
